import React from 'react'

class FormHeader extends React.Component {
    render () {
        return (
            <div className="form_header_wrap">
                <div className="form_header">{this.props.title}</div>
            </div>
        )
    }
}

export default FormHeader;